import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import nexus from "./assets/nexus.png";
import "./App.css";

function Policy() {
	const telegramBotLink = "https://t.me/NarekNexus_bot";
	return (
		<div className="App">
			{/* Header */}
			<header className="header">
				<motion.img
					src={nexus}
					className="App-logo"
					alt="Логотип Nexus"
					initial={{ opacity: 0, y: -20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8 }}
				/>
				<motion.h1
					className="title"
					initial={{ opacity: 0, x: -50 }}
					animate={{ opacity: 1, x: 0 }}
					transition={{ duration: 1 }}
				>
					<Link to="/" className="title-link">
						Nexus Shop
					</Link>
				</motion.h1>

				<motion.a
					href={telegramBotLink}
					className="telegram-link"
					rel="noopener noreferrer"
					initial={{ scale: 0.8 }}
					animate={{ scale: 1 }}
					transition={{ duration: 0.1, ease: "easeOut" }}
				>
					Перейти в Telegram-бот
				</motion.a>
			</header>

			{/* Offer Content */}
			<div className="main">
				<motion.div
					className="offer-content"
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8 }}
				>
					<h2>Публичная оферта</h2>
					<p>
						В соответствии с пунктом 2 статьи 437 Гражданского Кодекса
						Российской Федерации настоящий документ является предложением
						Индивидуального предпринимателя Маряняна Нарека Артуровича (ОГРНИП
						324774600644824, ИНН 772589975240), адресованным неограниченному
						кругу лиц о заключении договора оказания услуг.
					</p>
					<p>
						<strong>
							Договор считается заключенным на условиях настоящей публичной
							оферты с момента акцепта как он указан ниже по тексту.
						</strong>
					</p>

					<h3>1. Термины</h3>
					<p>
						В настоящей публичной оферте (далее по тексту - Оферта) термины и
						определения, указанные в настоящем разделе, используются в указанном
						ниже значении, если не оговорено иное.
					</p>
					<ol>
						<li>
							<strong>Приложение</strong> – программное обеспечение в виде
							мини-приложения под названием Nexus-Shop, расположенное в
							мессенджере Telegram по ссылке{" "}
							<a href="https://t.me/NarekNexus_bot">
								https://t.me/NarekNexus_bot
							</a>
							. Приложение предоставляет Заказчикам сведения об услугах
							Исполнителя, условиях их оплаты и оказания, и позволяет Заказчикам
							приобретать услуги Исполнителя на условиях Оферты. Во избежание
							неверного толкования, Исполнитель особо оговаривает, что не
							является владельцем товаров, размещенных в Приложении, а лишь
							оказывает услугу по их покупке и передаче Заказчику.
						</li>
						<li>
							<strong>Владелец Приложения</strong> – Индивидуальный
							предприниматель Марянян Нарек Артурович (ОГРНИП 324774600644824,
							ИНН 772589975240).
						</li>
						<li>
							<strong>Заказчик</strong> – физическое лицо, имеющее намерение
							приобрести услуги Исполнителя и разместившее Заказ на Сайте.
						</li>
						<li>
							<strong>Исполнитель</strong> – Индивидуальный предприниматель
							Марянян Нарек Артурович (ОГРНИП 324774600644824, ИНН
							772589975240), оказывающий услуги Заказчику лично или с
							привлечением третьих лиц.
						</li>
						<li>
							<strong>Услуга, услуги</strong> – услуги по покупке и дальнейшей
							передаче Заказчику встроенных в видеоигры товаров третьих лиц
							(внутриигровые покупки), предоставляемые Исполнителем и указанные
							в Приложении.
						</li>
						<li>
							<strong>Заказ</strong> – оформленный запрос Заказчика на оказание
							услуг Исполнителем по покупке размещенных в Приложении товаров
							третьих лиц, отправленный посредством сети Интернет.
						</li>
						<li>
							<strong>Стороны</strong> – Исполнитель и Заказчик согласно Оферте.
						</li>
					</ol>

					<h3>2. Общие положения</h3>
					<ol start="1">
						<li>
							Оферта разработана Исполнителем, является юридически обязательным
							соглашением между Заказчиком и Исполнителем, определяет условия
							предоставления услуг Исполнителя, указанных в Приложении, а также
							права и обязанности каждой из Сторон. Оферта является публичной
							офертой по смыслу ст. 437 ГК РФ.
						</li>
						<li>
							Заказчик обязан полностью ознакомиться с Офертой до момента
							Акцепта (принятия условий) как он указан ниже. Акцепт означает
							полное и безоговорочное принятие Заказчиком условий оферты в
							соответствии со ст. 438 Гражданского кодекса Российской Федерации.
						</li>
						<li>
							Оферта может быть изменена и/или дополнена Исполнителем без
							предварительного уведомления Заказчика. Такие изменения вступают в
							силу с момента опубликования новой редакции Оферты. Оферта
							является открытым и общедоступным документом. Действующая редакция
							Оферты располагается в сети Интернет по адресу:{" "}
							<a href="https://nexus-shop.ru/policy">
								https://nexus-shop.ru/policy
							</a>
							, а также в соответствующих разделах Приложения. Исполнитель
							рекомендует Заказчикам регулярно проверять условия Оферты на
							предмет ее изменений и/или дополнений.
						</li>
						<li>
							Заказывая услуги через Приложение, Заказчик соглашается с
							условиями их предоставления, содержащимися в Оферте, и принимает
							их в полном объеме.
						</li>
						<li>
							Акцептом (принятием условий) Оферты является любое из следующих
							действий:
							<ul>
								<li>
									Нажатие на кнопку «Пополнить баланс» в соответствующем разделе
									Приложения;
								</li>
								<li>
									Нажатие на кнопку «Купить» в соответствующем разделе
									Приложения;
								</li>
							</ul>
						</li>
						<li>
							Соглашаясь с условиями Оферты, Заказчик гарантирует, что обладает
							всеми необходимыми полномочиями и дееспособностью для акцепта
							Оферты.
						</li>
						<li>
							Условия Оферты распространяются на все услуги, представленные в
							Приложении.
						</li>
						<li>
							Учитывая, что доступ к услугам Исполнителя осуществляется через
							Приложение, к отдельным отношениям Сторон могут применяться
							положения Гражданского кодекса Российской Федерации о лицензионных
							договорах.
						</li>
					</ol>

					<h3>3. Оформление заказа</h3>
					<ol start="1">
						<li>
							Исполнитель размещает в Приложении описание, сроки исполнения,
							стоимость и иные параметры оказываемых услуг.
						</li>
						<li>
							Оформление заказа осуществляется путем добавления необходимого
							товара в корзину и нажатия на кнопку «Продолжить», «Купить» или
							аналогичных.
						</li>
						<li>
							Исполнитель и/или его представители вправе связаться с Заказчиком
							по предоставленным контактным данным для уточнения деталей Заказа.
						</li>
						<li>
							В связи с техническими особенностями Приложения, количество
							возможного к покупке товара и оказания Исполнителем услуг может
							отображаться неверно. В таком случае, Исполнитель вправе
							аннулировать Заказ и возвратить Заказчику уплаченные денежные
							средства.
						</li>
						<li>
							После оформления Заказа Исполнитель направляет Заказчику
							оповещение о совершенном Заказе и необходимости ожидания товара,
							также возможно направление дополнительной информации.
						</li>
					</ol>

					<h3>4. Условия оказания услуг</h3>
					<ol start="1">
						<li>
							Исполнитель вправе оказывать услуги лично или с привлечением
							третьих лиц, оставаясь ответственным перед Заказчиком.
						</li>
						<li>
							Обязанность Исполнителя оказать услугу считается исполненной в
							момент передачи товара Заказчику.
						</li>
						<li>
							Исполнитель особо уведомляет Заказчика, что предельного срока
							передачи товара не существует в связи с тем, что возможны
							технические неполадки со стороны владельцев товара, являющихся
							иностранными лицами. Однако, Исполнитель всегда старается
							осуществлять передачу товара в максимально короткие сроки.
						</li>
						<li>
							После оформления Заказа, Заказчик обязуется передать Исполнителю
							код для входа в игровой аккаунт, который направляется на его
							электронную почту. В случае непередачи кода Заказчик не вправе
							требовать от Исполнителя передачи товара, т.к. передача кода
							является необходимым для этого условием.
						</li>
						<li>
							После передачи Заказчиком кода из п. 4.4 Оферты, Исполнитель
							покупает на аккаунт Заказчика заказанный товар и выходит из его
							аккаунта, далее направляет Заказчику уведомление о совершении
							покупки и передаче товара.
						</li>
						<li>
							Передача товара Заказчику осуществляется путем размещения товара в
							его игровом аккаунте.
						</li>
						<li>
							Исполнитель не вправе совершать никаких действий в аккаунте
							Заказчика, кроме как покупки для его аккаунта заказанного товара.
						</li>
					</ol>

					<h3>5. Стоимость услуг и порядок оплаты</h3>
					<ol start="1">
						<li>
							Стоимость услуг Исполнителя включена в стоимость товара третьих
							лиц и указывается в описании товара в Приложении.
						</li>
						<li>
							Стоимость услуг может быть изменена Исполнителем в одностороннем
							порядке. При этом стоимость уже оплаченной услуги изменению не
							подлежит.
						</li>
						<li>В стоимость услуг включены все расходы Исполнителя.</li>
						<li>
							Услуги Исполнителя могут быть оплачены Заказчиком банковской
							картой при оформлении Заказа.
						</li>
						<li>
							Исполнитель вправе предоставлять скидки на свои услуги и
							устанавливать программу бонусов. Виды скидок, бонусов, порядок и
							условия начисления определяются Исполнителем самостоятельно и
							указываются в Приложении. Бонусы и скидки могут быть изменены
							Исполнителем в одностороннем порядке. Срок действия акций, скидок,
							бонусов устанавливается Исполнителем и доводится до сведения
							Заказчика в Приложении.
						</li>
						<li>
							Стороны особо оговаривают, что Исполнитель оказывает услуги по
							приобретению цифрового (виртуального) товара третьих лиц, которые
							ограничили доступ к своим товарам для граждан РФ, таким образом,
							Заказчик осознает, что возврат товара после его покупки произвести
							невозможно по независящим от Исполнителя причинам.
						</li>
						<li>
							Заказчик вправе отказаться от оплаченных услуг до момента начала
							их оказания Исполнителем. Возврат уплаченных денежных средств в
							таком случае производится в том же порядке, в каком услуги были
							оплачены.
						</li>
					</ol>

					<h3>6. Пределы использования</h3>
					<ol start="1">
						<li>
							Заказчик вправе использовать Приложение способами, описанными в
							настоящей Оферте, на всей территории Российской Федерации, а также
							иных территориях, на которых они доступны.
						</li>
						<li>
							Если Заказчику в соответствии с законами его государства запрещено
							пользоваться Приложением или существуют иные законодательные
							ограничения, включая ограничения по возрасту допуска к подобным
							Приложениям, Заказчик не вправе использовать Приложение. Заказчик
							самостоятельно несет ответственность за использование Приложения
							на территории своего государства и нарушение местного
							законодательства.
						</li>
						<li>
							Использование Приложения осуществляется в состоянии «как есть».
						</li>
						<li>
							Исполнитель предоставляет Заказчику следующие права использования
							Приложения:
							<ul>
								<li>
									право пользования Приложением в соответствии с его
									назначением, в том числе посредством удаленного доступа к нему
									через сеть Интернет;
								</li>
								<li>
									право воспроизведения Приложения на персональных устройствах;
								</li>
								<li>
									право переработки Приложения, предусматривающее внесение с
									помощью функционала Приложения изменений в пределах,
									необходимых для работы Заказчика со своими данными;
								</li>
								<li>
									право использования Приложения иными способами, не
									противоречащими положениям Оферты.
								</li>
							</ul>
						</li>
						<li>
							Заказчик не вправе:
							<ul>
								<li>
									Дублировать, копировать, продавать, распространять и
									перепродавать любые элементы дизайна или пользовательского
									интерфейса Приложения;
								</li>
								<li>
									Перерабатывать Приложение в пределах, прямо не предусмотренных
									Офертой;
								</li>
								<li>
									Использовать Приложение иными способами, не предусмотренными
									Офертой и выходящими за рамки обычного процесса
									функционирования Приложения.
								</li>
							</ul>
						</li>
					</ol>

					<h3>7. Права и обязанности Сторон</h3>
					<h4>7.1. Исполнитель обязан:</h4>
					<ol start="1">
						<li>
							Предоставить Заказчику услуги в соответствии с условиями Оферты и
							описания в Приложении.
						</li>
						<li>
							Уведомлять Заказчика о невозможности оказания оплаченной услуги.
						</li>
					</ol>
					<h4>7.2. Исполнитель вправе:</h4>
					<ol start="1">
						<li>
							Проводить профилактические или иные работы в Приложении без
							предварительного уведомления Заказчика, вследствие чего некоторые
							функции, в том числе оформление Заказа, могут быть недоступны в
							целом или частично.
						</li>
						<li>
							В любое время изменять стоимость своих услуг. Указанный порядок не
							распространяется на оформленные Заказы.
						</li>
					</ol>
					<h4>7.3. Заказчик обязан:</h4>
					<ol start="1">
						<li>
							Ознакомиться с Офертой до момента принятия ее условий (акцепта) и
							соблюдать условия Оферты.
						</li>
						<li>Самостоятельно отслеживать изменение условий Оферты.</li>
						<li>
							Указывать достоверную информацию при заполнении любых форм в
							Приложении.
						</li>
						<li>
							Не сообщать третьим лицам данные, используемые для доступа к
							Приложению.
						</li>
						<li>
							Уведомить Владельца приложения в случае, если у него возникнут
							подозрения относительно безопасности его аккаунта или возможности
							его несанкционированного использования третьими лицами, направив
							сообщение по адресу электронной почты{" "}
							<a href="mailto:support@nexus-shop.ru">support@nexus-shop.ru</a>.
						</li>
						<li>
							Не вносить в любые формы заполнения данных в Приложении информацию
							и данные, содержащие:
							<ul>
								<li>
									гиперссылки или информацию о других интернет-сайтах,
									содержащие информацию и сведения, запрещенные действующим
									законодательством РФ или требующие специальной пометки для
									такой информации, а также содержащие спам-контент;
								</li>
								<li>
									заимствованные без получения согласия правообладателя
									фото-видео-текстовые материалы, а также изображения людей без
									их письменного согласия;
								</li>
								<li>
									требования, ограничения, запреты или иным любым способом
									выраженные предпочтения, относящиеся к гражданству,
									национальности, вероисповеданию, цвету кожи, расы, этническому
									происхождению;
								</li>
								<li>
									оскорбления в адрес любых лиц или которые могут быть расценены
									в качестве таковых, дискредитирующие любых лиц;
								</li>
								<li>
									угрозы, призывы к насилию, совершению противоправных деяний,
									антиобщественных, аморальных поступков, а также совершению
									любых иных действий, противоречащих основам правопорядка и
									нравственности;
								</li>
								<li>
									ущерб чести, достоинству и деловой репутации гражданина или
									деловой репутации организации;
								</li>
								<li>нецензурные слова и выражения;</li>
								<li>
									информацию эротического и/или порнографического характера;
								</li>
								<li>
									пропаганду суицида, описание способов суицида и любое
									подстрекательство к его совершению;
								</li>
								<li>
									любую информацию о наркотических и психотропных веществах, в
									том числе, информацию о распространении наркотиков, рецепты их
									изготовления и советы по употреблению, а также размещать
									информацию экстремистской направленности;
								</li>
								<li>
									персональные данные физических лиц, кроме собственных данных
									Заказчика, без их предварительного согласия.
								</li>
							</ul>
						</li>
					</ol>
					<h4>7.4. Заказчик вправе:</h4>
					<ol start="1">
						<li>
							Переуступать либо каким-то иным способом передавать свои права и
							обязанности третьим лицам, вытекающие из его отношений с
							Исполнителем, только с согласия Исполнителя.
						</li>
						<li>
							Отказаться от оплаченных услуг до момента начала их оказания
							Исполнителем в соответствии с условиями Оферты.
						</li>
					</ol>

					<h3>8. Ответственность</h3>
					<ol start="1">
						<li>
							В случае форс-мажорных обстоятельств, документально подтвержденных
							соответствующими органами, стороны освобождаются от исполнения
							настоящего договора.
						</li>
						<li>
							Исполнитель не несет ответственности за неисполнение либо
							ненадлежащее исполнение своих обязательств вследствие сбоев в
							телекоммуникационных и энергетических сетях, действий вредоносных
							программ, а также недобросовестных действий третьих лиц,
							направленных на несанкционированный доступ и/или выведение из
							строя программного и/или аппаратного комплекса Приложения. Вместе
							с тем, Исполнитель обязуется принимать все разумные меры для
							предотвращения таких перебоев.
						</li>
						<li>
							Исполнитель не несет ответственности в случае ошибочного понимания
							услуги Заказчиком, его субъективных ожиданий от услуги.
						</li>
						<li>
							Исполнитель не несет ответственность за невозможность исполнения
							своих обязательств перед Заказчиком, вызванных действиями третьих
							лиц, в том числе разработчиков/издателей видеоигр, в которых
							Заказчик намерен приобрести товар.
						</li>
						<li>
							Сайт содержит материалы, охраняемые авторским правом, товарные
							знаки и иные охраняемые законом материалы, включая, но не
							ограничиваясь: тексты, фотографии, видео, графические изображения.
							Исполнителю принадлежат исключительные права на использование
							содержания Приложения. Заказчик не имеет права вносить изменения,
							публиковать, передавать третьим лицам, участвовать в продаже или
							уступке, создавать производные продукты или иным образом
							использовать, частично или полностью, содержание Приложения.
						</li>
					</ol>

					<h3>9. Заключительные положения</h3>
					<ol start="1">
						<li>
							Оферта вступает в силу с момента ее акцепта Заказчиком и действует
							до момента ее фактического исполнения.
						</li>
						<li>
							К отношениям между Заказчиком и Исполнителем применяются положения
							Российского законодательства.
						</li>
						<li>
							Стороны прилагают максимальные усилия с целью устранения
							возникающих разногласий путем переговоров. Срок ответа на
							досудебную претензию составляет 15 календарных дней с момента
							получения претензии. В случае недостижения согласия путем
							переговоров, спор подлежит разрешению в суде в соответствии с
							действующим законодательством.
						</li>
						<li>
							Признание судом недействительности какого-либо положения Оферты не
							влечет за собой недействительность остальных положений.
						</li>
						<li>
							По любым вопросам, связанным с исполнением Оферты, оказанием услуг
							Исполнителем, претензиями и вопросами, Заказчик вправе обращаться
							на электронную почту Исполнителя{" "}
							<a href="mailto:narmargold@gmail.com">narmargold@gmail.com</a>.
						</li>
					</ol>
				</motion.div>
			</div>

			{/* Footer */}
			<motion.footer
				className="footer"
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ duration: 1, delay: 1 }}
			>
				<p>© 2024 Nexus Shop. Все права защищены.</p>
				<p>
					ИП Марянян Нарек Артурович
					<br />
					ОГРНИП: 324774600644824
					<br />
					ИНН: 772589975240
					<br />
					Почта: narmargold@gmail.com
				</p>
			</motion.footer>
		</div>
	);
}

export default Policy;
